import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AssignmentToDutyEntity } from './assignment-to-duty.model';

export enum AssignmentToDutyActionTypes {
  LoadAssignmentToDuties = '[AssignmentToDuty] Load AssignmentToDuties',
  AddAssignmentToDuty = '[AssignmentToDuty] Add AssignmentToDuty',
  UpsertAssignmentToDuty = '[AssignmentToDuty] Upsert AssignmentToDuty',
  AddAssignmentToDuties = '[AssignmentToDuty] Add AssignmentToDuties',
  UpsertAssignmentToDuties = '[AssignmentToDuty] Upsert AssignmentToDuties',
  UpdateAssignmentToDuty = '[AssignmentToDuty] Update AssignmentToDuty',
  UpdateAssignmentToDuties = '[AssignmentToDuty] Update AssignmentToDuties',
  DeleteAssignmentToDuty = '[AssignmentToDuty] Delete AssignmentToDuty',
  DeleteAssignmentToDuties = '[AssignmentToDuty] Delete AssignmentToDuties',
  ClearAssignmentToDuties = '[AssignmentToDuty] Clear AssignmentToDuties',
}

export class LoadAssignmentToDuties implements Action {
  public readonly type = AssignmentToDutyActionTypes.LoadAssignmentToDuties;

  constructor(public payload: { assignmentToDuties: AssignmentToDutyEntity[] }) {}
}

export class AddAssignmentToDuty implements Action {
  public readonly type = AssignmentToDutyActionTypes.AddAssignmentToDuty;

  constructor(public payload: { assignmentToDuty: AssignmentToDutyEntity }) {}
}

export class UpsertAssignmentToDuty implements Action {
  public readonly type = AssignmentToDutyActionTypes.UpsertAssignmentToDuty;

  constructor(public payload: { assignmentToDuty: AssignmentToDutyEntity }) {}
}

export class AddAssignmentToDuties implements Action {
  public readonly type = AssignmentToDutyActionTypes.AddAssignmentToDuties;

  constructor(public payload: { assignmentToDuties: AssignmentToDutyEntity[] }) {}
}

export class UpsertAssignmentToDuties implements Action {
  public readonly type = AssignmentToDutyActionTypes.UpsertAssignmentToDuties;

  constructor(public payload: { assignmentToDuties: AssignmentToDutyEntity[] }) {}
}

export class UpdateAssignmentToDuty implements Action {
  public readonly type = AssignmentToDutyActionTypes.UpdateAssignmentToDuty;

  constructor(public payload: { assignmentToDuty: Update<AssignmentToDutyEntity> }) {}
}

export class UpdateAssignmentToDuties implements Action {
  public readonly type = AssignmentToDutyActionTypes.UpdateAssignmentToDuties;

  constructor(public payload: { assignmentToDuties: Update<AssignmentToDutyEntity>[] }) {}
}

export class DeleteAssignmentToDuty implements Action {
  public readonly type = AssignmentToDutyActionTypes.DeleteAssignmentToDuty;

  constructor(public payload: { id: string }) {}
}

export class DeleteAssignmentToDuties implements Action {
  public readonly type = AssignmentToDutyActionTypes.DeleteAssignmentToDuties;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearAssignmentToDuties implements Action {
  public readonly type = AssignmentToDutyActionTypes.ClearAssignmentToDuties;
}

export type AssignmentToDutyActions =
  | LoadAssignmentToDuties
  | AddAssignmentToDuty
  | UpsertAssignmentToDuty
  | AddAssignmentToDuties
  | UpsertAssignmentToDuties
  | UpdateAssignmentToDuty
  | UpdateAssignmentToDuties
  | DeleteAssignmentToDuty
  | DeleteAssignmentToDuties
  | ClearAssignmentToDuties;
